"use client";
import { createContext, ReactNode, useContext, SetStateAction, useState, useEffect } from "react";
import { usePathname } from "next/navigation";

interface IContextType {
    quickAdd: boolean;
    setQuickAdd: React.Dispatch<SetStateAction<boolean>>;
    resetQuickAddContext: React.Dispatch<SetStateAction<boolean>>;
}

export const INITIAL_QUICK_ADD_DATA = {
    quickAdd: false,
    setQuickAdd: () => false,
    resetQuickAddContext: () => false,
};

const QuickAddContext =  createContext<IContextType>(INITIAL_QUICK_ADD_DATA);

export const QuickAddProvider = ({ children }: { children: React.ReactNode }) => {
    const [quickAdd, setQuickAdd] = useState(false);
    const pathname = usePathname();

    const resetQuickAddContext = () => {
        setQuickAdd(false);
    }

    useEffect(() => {
        resetQuickAddContext();
    }, [pathname]);



    return <QuickAddContext.Provider value={{ quickAdd, setQuickAdd, resetQuickAddContext }}>{children}</QuickAddContext.Provider>;
};

export const useQuickAdd = () => useContext(QuickAddContext);
